export * from './useDeleteGlobalMaterial'
